import { Stack, Typography } from "@mui/material";

export const SettingsInfoBlock = ({
  mainText,
  dataElements
}: {
  mainText: string;
  dataElements: {
    element: React.ReactNode;
    dataLabel?: string;
  }[];
}) => {
  return (
    <Stack
      role="presentation"
      aria-label="Settings info block"
      direction="row"
      gap={2}
      alignItems="baseline"
    >
      <Typography
        variant="body1"
        alignSelf="flex-start"
        width="110px"
        color="text.secondary"
      >
        {mainText}
      </Typography>
      <Stack direction="row" gap={2} width="130px">
        {dataElements.map(({ element, dataLabel }, index) => (
          <Stack
            key={`${mainText}-${dataLabel ?? "element"}-${index}`}
            direction="column"
          >
            {element}
            <Typography variant="caption" color="textSecondary">
              {dataLabel ?? ""}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
